import React, { useState, useEffect } from "react";
import "./theme/cssReactToastNotifications/react-toast-notificatons.css";
import { Grid, Typography, AppBar, Toolbar } from "@mui/material";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Config from "./Configuracion/Configuraciones";
import RutasComponente from "./Configuracion/RutaComponentes";
import AsignaIdomaEtiquetas, {
  obtenerMensajeIdiomaCodigo,
  enlistaArrayCodigosMensajesIdiomas,
} from "./Actions/Generales/IdiomasAction";
import {
  obtenerCompaniaDefecto,
  obtenerConfiguracionAppCompania,
} from "./Actions/Companias/CompaniaAction";

import { StyleApp, styleBarMovil } from "./Componentes/Tool/Style";
import { MyDialog } from "./Componentes/ControlUsuario/Cargando";
import Idioma from "./Componentes/Idiomas/Idioma";
import { MostrarMensaje } from "./Utilidades/ManejoMensajes";

//imagen
import { ImagenesBGHeaderHome } from "./Configuracion/Llaves/ImgBGHomeHeader";
import {
  LlavesConfiguraciones,
  GnlIdiomaDefecto,
} from "./Configuracion/Llaves/RepositorioConfig";
import {
  defaultNavBarColor,
  defaultNavLineColor,
  defaultNavTextColor,
  defaultNavIconColor,
  defaultNavIconBG,
} from "./Componentes/Tool/PaletaColores";

import { useGlobalState } from "./Utilidades/useGlobalState";

import { useToasts } from "react-toast-notifications";
import useFirstRender from "./Utilidades/useFirstRender";

function App() {
  const { addToast } = useToasts();
  const firstRender = useFirstRender();

  const {
    autorizacion,
    codigoIdioma,
    openSnackbar,
    etiquetas,
    compania,
    dispatch,
  } = useGlobalState();

  const [iniciaApp, setIniciaApp] = useState(false);

  const [autorizaUsuario, setAutorizaUsuario] = useState({
    Rutas: RutasComponente.Rutas,
    RutaHome: RutasComponente.RutaHome,
    RutaNotFound: RutasComponente.RutaNotFound,
    Modulo: RutasComponente.Modulo,
  });

  const classBarMovil = styleBarMovil();

  useEffect(() => {
    //Se toma el idioma del LocalStorage de no estar definido devuelve nulo.
    const etiIdioma = window.localStorage.getItem(
      "etiqueta_idioma_NuevoEstudiante_CIF",
    );
    if (etiIdioma !== undefined && etiIdioma !== null && etiIdioma !== "")
      AsignaIdomaEtiquetas(etiIdioma, dispatch);
    else AsignaIdomaEtiquetas(GnlIdiomaDefecto, dispatch);

    LoadCompanyProperties();
    //BuscarCompaniaDefecto();
    setIniciaApp(true);
    // Se realiza la asignacion del idioma a las etiquetas de los componentes cuando el app se inicio
    //La variable etiIdioma de ser nula devuelve el idioma por defecto que es ES
  }, []);

  const ObtenerCompaniaDefectoCodigo = async () => {
    const Objeto = {
      Code: LlavesConfiguraciones.codigoCompaniaLogin,
    };

    const response = await obtenerCompaniaDefecto(Objeto);

    if (response.status === 200) {
      //si la respuesta fue existosa
      return response.data;
    } else {
      if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors,
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }
    }
  };

  const LoadCompanyProperties = async () => {
    dispatch({
      type: "LOAD_HOME",
      texto: etiquetas.CargandoModal.Et_Procesando,
    });

    try {
      const idCompanyLoginEstudiante = await ObtenerCompaniaDefectoCodigo();

      const ComConfResp = await obtenerConfiguracionAppCompania(
        idCompanyLoginEstudiante,
      );

      if (ComConfResp.status === 200) {
        const imgBGDesktopShow =
          ComConfResp?.data["cfgImgBGDesktop"] !== ""
            ? ComConfResp?.data["cfgImgBGDesktop"]
            : ImagenesBGHeaderHome.ImgBGDesktop;
        const imgBGMovilShow =
          ComConfResp?.data["cfgImgBGMovil"] !== ""
            ? ComConfResp?.data["cfgImgBGMovil"]
            : ImagenesBGHeaderHome.ImgBGMovil;

        const temNavBarColor =
          ComConfResp?.data["cfgNavBarColor"] !== ""
            ? ComConfResp?.data["cfgNavBarColor"]
            : defaultNavBarColor;
        const temNavLineColor =
          ComConfResp?.data["cfgNavLineColor"] !== ""
            ? ComConfResp?.data["cfgNavLineColor"]
            : defaultNavLineColor;
        const temNavTextColor =
          ComConfResp?.data["cfgNavTextColor"] !== ""
            ? ComConfResp?.data["cfgNavTextColor"]
            : defaultNavTextColor;
        const temNavIconColor =
          ComConfResp?.data["cfgNavIconColor"] !== ""
            ? ComConfResp?.data["cfgNavIconColor"]
            : defaultNavIconColor;
        const temNavIconBG =
          ComConfResp?.data["cfgNavIconBG"] !== ""
            ? ComConfResp?.data["cfgNavIconBG"]
            : defaultNavIconBG;
        const temLogoBG =
          ComConfResp?.data["cfgLogoBG"] !== ""
            ? ComConfResp?.data["cfgLogoBG"]
            : defaultNavIconBG;

        dispatch({
          type: "ESTABLECER_COMPANY",
          CfgConfigId: ComConfResp?.data["cfgConfigId"],
          ComCompanyId: ComConfResp?.data["cfgCompanyIdFk"],
          ComName: ComConfResp?.data["cfgCompanyName"],
          CfgNavBarColor: temNavBarColor,
          CfgNavLineColor: temNavLineColor,
          CfgNavTextColor: temNavTextColor,
          CfgNavIconColor: temNavIconColor,
          CfgNavIconBG: temNavIconBG,
          CfgLogoBG: temLogoBG,
          CfgImgBGDesktop: 'url("' + imgBGDesktopShow + '")',
          CfgImgBGMovil: 'url("' + imgBGMovilShow + '")',
          tokenByEmail: ComConfResp?.data["tokenByEmail"],
          portalNewEntry: ComConfResp?.data["portalNewEntry"],
          portalAdministrative: ComConfResp?.data["portalAdministrative"],
          portalStudent: ComConfResp?.data["portalStudent"],
          portalTeachers: ComConfResp?.data["portalTeachers"],
          zerobounce: ComConfResp?.data["zerobounce"],
          zerobounceUrl: ComConfResp?.data["zerobounceUrl"],
          zerobounceApiKey: ComConfResp?.data["zerobounceApiKey"],
          idcConfigId: ComConfResp?.data["idcConfigId"],
          idcIsActive: ComConfResp?.data["idcIsActive"],
          idcProviderCode: ComConfResp?.data["idcProviderCode"],
          idcProviderName: ComConfResp?.data["idcProviderName"],
          idcIdentificationType: ComConfResp?.data["idcIdentificationType"],
        });
      } else {
        dispatch({
          type: "ESTABLECER_COMPANY",
          CfgConfigId: "",
          ComCompanyId: idCompanyLoginEstudiante,
          ComName:
            etiquetas?.EtiquetasComponente?.AppBarLang?.Et_TituloPrincipal,
          CfgNavBarColor: defaultNavBarColor,
          CfgNavLineColor: defaultNavLineColor,
          CfgNavTextColor: defaultNavTextColor,
          CfgNavIconColor: defaultNavIconColor,
          CfgNavIconBG: defaultNavIconBG,
          CfgLogoBG: "#ffffff",
          CfgImgBGDesktop: 'url("' + ImagenesBGHeaderHome.ImgBGDesktop + '")',
          CfgImgBGMovil: 'url("' + ImagenesBGHeaderHome.ImgBGMovil + '")',
          tokenByEmail: false,
          portalNewEntry: false,
          portalAdministrative: false,
          portalStudent: false,
          portalTeachers: false,
          zerobounce: false,
          zerobounceUrl: "",
          zerobounceApiKey: "",
          idcConfigId: "",
          idcIsActive: false,
          idcProviderCode: "",
          idcProviderName: "",
          idcIdentificationType: "",
        });
      }
    } catch (error) {
      dispatch({
        type: "ESTABLECER_COMPANY",
        CfgConfigId: "",
        ComCompanyId: "",
        ComName: etiquetas?.EtiquetasComponente?.AppBarLang?.Et_TituloPrincipal,
        CfgNavBarColor: defaultNavBarColor,
        CfgNavLineColor: defaultNavLineColor,
        CfgNavTextColor: defaultNavTextColor,
        CfgNavIconColor: defaultNavIconColor,
        CfgNavIconBG: defaultNavIconBG,
        CfgLogoBG: "#ffffff",
        CfgImgBGDesktop: 'url("' + ImagenesBGHeaderHome.ImgBGDesktop + '")',
        CfgImgBGMovil: 'url("' + ImagenesBGHeaderHome.ImgBGMovil + '")',
        tokenByEmail: false,
        portalNewEntry: false,
        portalAdministrative: false,
        portalStudent: false,
        portalTeachers: false,
        zerobounce: false,
        zerobounceUrl: "",
        zerobounceApiKey: "",
        idcConfigId: "",
        idcIsActive: false,
        idcProviderCode: "",
        idcProviderName: "",
        idcIdentificationType: "",
      });
      // Opcional: puedes mostrar un mensaje de error aquí si lo deseas
      console.error("Error al cargar propiedades de la compañía:", error);
    }

    dispatch({ type: "CLOSE_LOAD_HOME" });
  };

  useEffect(() => {
    // se valida el set del objeto que maneja la ruta para determinar si es por el archivo de rutas o del reducer
    let autorizacionUsuario = autorizacion ? autorizacion : RutasComponente; // se extrae la navegacion del reducer
    // En caso de ser nulo se dejan las rutas del archivo de rutas inicial que esta todo como denegado
    // caso contrario lo toma del reducer de rutas

    // se llama al dispatch para que como tal se actualice el reducer
    setAutorizaUsuario({
      Rutas: autorizacionUsuario.Rutas,
      RutaHome: autorizacionUsuario.RutaHome,
      RutaNotFound: autorizacionUsuario.RutaNotFound,
      Modulo: autorizacionUsuario.Modulo,
    });
  }, [autorizacion]);

  useEffect(() => {
    if (firstRender) {
      return;
    }
    if (openSnackbar !== undefined) {
      if (openSnackbar.open) {
        const listadoMensajes = openSnackbar.mensaje;
        listadoMensajes.forEach(function (codigo) {
          addToast(obtenerMensajeIdiomaCodigo(codigoIdioma, codigo).mensaje, {
            appearance: openSnackbar.severity,
          });
        });
      }
    }
  }, [openSnackbar]);

  return iniciaApp === false ? null : (
    <React.Fragment>
      <MyDialog />
      <Router>
        <AppBar
          position="relative"
          style={{
            backgroundColor: compania.CfgNavBarColor,
            height: 50,
            flexDirection: "column",
            justifyContent: "center",
            zIndex: 500,
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            borderBottom: "solid " + compania.CfgNavLineColor + " 3.5px",
          }}
        >
          <Toolbar style={{ minHeight: 40 }}>
            <Typography
              variant="h2"
              style={{ color: compania.CfgNavTextColor, marginLeft: 10 }}
            >
              {etiquetas.NombrePortal.Et_Nombre}
            </Typography>
            <div className={classBarMovil.grow}></div>
            <div className={classBarMovil.seccionDesktop}>
              <Idioma />
            </div>
          </Toolbar>
        </AppBar>
        <Grid
          container
          style={{ ...StyleApp.DivAppGeneral, ...{ marginTop: "50px" } }}
        >
          <Switch>
            <Route
              exact
              path={Config.rutaPublicacion + "/home"}
              component={autorizaUsuario.RutaHome.component}
            />
            <Route
              exact
              path={Config.rutaPublicacion + "/"}
              component={autorizaUsuario.RutaHome.component}
            />
            <Route
              exact
              path={Config.rutaPublicacion + autorizaUsuario.RutaNotFound.path}
              component={autorizaUsuario.RutaNotFound.component}
            />
          </Switch>
        </Grid>
      </Router>
    </React.Fragment>
  );
}

export default App;
